import React from 'react';
import { connect } from 'react-redux';
import { getLogger } from 'utils/logger';
import { getProfile } from 'data/profile/selectors';
import { getAuthSession } from 'utils/auth/utils';
import { Config, BUILD_TYPE } from 'utils/webappConfig';
import tracker from 'utils/tracker';

const log = getLogger('utils/intercom.js');
const APP_ID = Config.builds[BUILD_TYPE].intercom_app_id;

class Intercom extends React.PureComponent {

  constructor(props) {
    super(props);

    /* eslint-disable */

    if (APP_ID) {
      //Set your APP_ID
      try {
        (function () {
          var w = window;
          var ic = w.Intercom;
          if (typeof ic === 'function') {
            ic('reattach_activator');
            ic('update', w.intercomSettings);
          } else {
            var d = document;
            var i = function () {
              i.c(arguments);
            };
            i.q = [];
            i.c = function (args) {
              i.q.push(args);
            };
            w.Intercom = i;
            var l = function () {
              var s = d.createElement('script');
              s.type = 'text/javascript';
              s.async = true;
              s.src = 'https://widget.intercom.io/widget/' + APP_ID;
              var x = d.getElementsByTagName('script')[0];
              x.parentNode.insertBefore(s, x);
            };
            if (document.readyState === 'complete') {
              l();
            } else if (w.attachEvent) {
              w.attachEvent('onload', l);
            } else {
              w.addEventListener('load', l, false);
            }
          }
        })();

        window.intercomSettings = {
          app_id: APP_ID,
          custom_launcher_selector: '#intercom-launcher',
        }
        this.updateIntercom();
      } catch (error) {
        log.error(error);
      }
    }
  }

  updateIntercom() {
    if (window.Intercom) {
      if (this.props.profile && this.props.authSession) {
        const name = [...(this.props.profile.firstName ? [this.props.profile.firstName] : []), ...(this.props.profile.lastName ? [this.props.profile.lastName] : [])].join(' ');
        window.Intercom('boot');
        window.Intercom('onShow', () => {
          tracker.track(tracker.events.showIntercom);
        });
        window.Intercom('update', {
          user_id: this.props.authSession.qcsId,
          qcs_id: this.props.authSession.qcsId,
          dataset_id: this.props.authSession.datasetId,
          email: this.props.profile.username,
          name,
        });
      } else {
        window.Intercom('shutdown');
      }
    }
  }

  render() {
    return null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.profile !== prevProps.profile || this.props.authSession !== prevProps.authSession) {
      this.updateIntercom();
    }
  }

  componentWillUnmount() {
    if (window.Intercom) {
      window.Intercom('shutdown');
    }
  }

}

const mapStateToProps = (state) => ({
  profile: getProfile(state),
  authSession: getAuthSession(state),
});

export default connect(mapStateToProps)(Intercom);
